import React from "react";
import { Dropdown } from "primereact/dropdown";
import { TICKET_AGENT_OPTIONS } from "../../constants/ticketAgents";

const priorityOptions = ["Low", "Medium", "High", "Urgent"];

export const TicketListFilters = ({ filters, onChange, onClear, onClose }) => {
  return (
    <div className="workspace-filters">
      <div className="workspace-filter-header">
        <h4>Ticket Filter</h4>
        <button type="button" onClick={onClose}>
          x
        </button>
      </div>
      <Dropdown
        value={filters.priority}
        options={priorityOptions}
        placeholder="Select Priority"
        showClear
        onChange={(event) => onChange("priority", event.value || "")}
      />
      <Dropdown
        value={filters.assignedTo}
        options={TICKET_AGENT_OPTIONS}
        placeholder="Select Agent"
        showClear
        onChange={(event) => onChange("assignedTo", event.value || "")}
      />
      <div className="workspace-filter-actions">
        <button type="button" className="workspace-clear-btn" onClick={onClear}>
          Clear
        </button>
        <button type="button" className="workspace-save-btn-sm" onClick={onClose}>
          Save
        </button>
      </div>
    </div>
  );
};

export default TicketListFilters;
